import { Injectable, } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RateService {
  base_url: string;
  constructor(public http: HttpClient,
  ) {
   this.base_url = environment.appUrl + "/rates";
   }

  getRates(): Observable<any> {
    return this.http.get(this.base_url);
  }

  updateRates(fleetId, rate, rateType): Observable<any> {
    return this.http.put(this.base_url + "/fleet/?fleetId=" + fleetId + '&rate=' + rate + '&rateType=' + rateType, null);
  }
}
